import { render, staticRenderFns } from "./SGReadyAdvancedSettings.vue?vue&type=template&id=2904d73e&scoped=true&"
import script from "./SGReadyAdvancedSettings.vue?vue&type=script&lang=js&"
export * from "./SGReadyAdvancedSettings.vue?vue&type=script&lang=js&"
import style0 from "./SGReadyAdvancedSettings.vue?vue&type=style&index=0&id=2904d73e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2904d73e",
  null
  
)

export default component.exports